<template>
  <v-row dense align="center">
    <DatetimeRangePicker
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      :disabled="disabled"
      v-model="datetimeRange"
      v-if="!$vuetify.theme.dark"
      :label="selected ? radios.find((r) => r.key == selected).text : label"
      :removeIcon="removeIcon"
      :switchIcon="switchIcon"
    >
      <template v-slot:header>
        <v-radio-group v-if="showRadios" v-model="selected" row hide-details>
          <v-radio
            v-for="radio in radios"
            :label="radio.text"
            :key="radio.key"
            :value="radio.key"
          ></v-radio>
        </v-radio-group>
        <v-divider v-if="showRadios" />
      </template>
      <template v-slot:switchAction>
        <span v-if="switchIcon">
          <v-tooltip top v-if="timeSyncFlg">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                text
                @click.stop="$emit('switchAction')"
              >
                <v-icon color="primary">fa-toggle-off</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("stockOrderAnalyze.Fields.timeSync") }}</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                text
                @click.stop="$emit('switchAction')"
              >
                <v-icon color="primary">fa-toggle-on</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("stockOrderAnalyze.Fields.NoTimeSync") }}</span>
          </v-tooltip>
        </span>
      </template>
    </DatetimeRangePicker>
    <DatetimeRangePickerDark
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      :disabled="disabled"
      v-model="datetimeRange"
      v-if="$vuetify.theme.dark"
      :label="selected ? radios.find((r) => r.key == selected).text : label"
      :removeIcon="removeIcon"
      :switchIcon="switchIcon"
    >
      <template v-slot:header>
        <v-radio-group v-if="showRadios" v-model="selected" row hide-details>
          <v-radio
            v-for="radio in radios"
            :label="radio.text"
            :key="radio.key"
            :value="radio.key"
          ></v-radio>
        </v-radio-group>
        <v-divider v-if="showRadios" />
      </template>
      <template v-slot:switchAction>
        <span v-if="switchIcon">
          <v-tooltip top v-if="timeSyncFlg">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                text
                @click.stop="$emit('switchAction')"
              >
                <v-icon color="primary">fa-toggle-off</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("stockOrderAnalyze.Fields.timeSync") }}</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                text
                @click.stop="$emit('switchAction')"
              >
                <v-icon color="primary">fa-toggle-on</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("stockOrderAnalyze.Fields.NoTimeSync") }}</span>
          </v-tooltip>
        </span>
      </template>
    </DatetimeRangePickerDark>
  </v-row>
</template>

<style scoped>
.v-input--selection-controls {
  margin-top: 0;
  padding: 6px;
}
</style>

<script>
import DatetimeRangePicker from "@/plugins/datepicker/DatetimeRangePicker";
import DatetimeRangePickerDark from "@/plugins/datepicker/DatetimeRangePickerDark";

export default {
  name: "SearcherDatetimeRangeWithRadio",

  props: {
    value: [Array, Object],
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    showRadios: Boolean,
    radios: Array,
    disabled: Boolean,
    removeIcon: Boolean,
    switchIcon: Boolean,
    timeSyncFlg: Boolean, //用于出入库统计时间搜索
  },

  components: {
    DatetimeRangePicker,
    DatetimeRangePickerDark,
  },

  data: () => ({
    selected: null,
    datetimeRange: [
      new Date().toISOString().substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
  }),

  methods: {
    changedVal() {
      if (!this.radios || !this.selected) return null;

      var newVal = {
        datetimeRadioSelected: this.selected,
      };
      this.radios.forEach((radio) => {
        newVal[
          radio.key + (this.type == "date" ? "_date_from" : "_time_from")
        ] =
          this.selected == radio.key && this.datetimeRange[0]
            ? this.datetimeRange[0]
            : "";
        newVal[radio.key + (this.type == "date" ? "_date_to" : "_time_to")] =
          this.selected == radio.key && this.datetimeRange[1]
            ? this.datetimeRange[1]
            : "";
      });

      var result =
        this.value.datetimeRadioSelected == newVal.datetimeRadioSelected;
      if (result)
        this.radios.forEach((radio) => {
          result =
            result &&
            this.value[
              radio.key + (this.type == "date" ? "_date_from" : "_time_from")
            ] ==
              newVal[
                radio.key + (this.type == "date" ? "_date_from" : "_time_from")
              ] &&
            this.value[
              radio.key + (this.type == "date" ? "_date_to" : "_time_to")
            ] ==
              newVal[
                radio.key + (this.type == "date" ? "_date_to" : "_time_to")
              ];
        });

      return result ? null : newVal;
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      deep: true,
      handler() {
        if (!this.radios) this.datetimeRange = this.value;
        else {
          this.selected = this.value.datetimeRadioSelected
            ? this.value.datetimeRadioSelected
            : this.radios[0].key;
          this.datetimeRange = [
            this.value[
              this.selected +
                (this.type == "date" ? "_date_from" : "_time_from")
            ],
            this.value[
              this.selected + (this.type == "date" ? "_date_to" : "_time_to")
            ],
          ];
        }
      },
    },
    selected: {
      handler() {
        var changedVal = this.changedVal();
        if (changedVal)
          this.$emit("input", Object.assign({}, this.value, changedVal));
      },
    },
    datetimeRange: {
      handler() {
        if (!this.radios) this.$emit("input", this.datetimeRange);
        else {
          var changedVal = this.changedVal();
          if (changedVal)
            this.$emit("input", Object.assign({}, this.value, changedVal));
        }
      },
    },
  },
};
</script>
